<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('huntingWordsGenerator.create.subtitle') }}
        </span>
        <h3 class="page-title d-inline">
          {{ $t('huntingWordsGenerator.create.title') }}
        </h3>
      </d-col>
    </d-row>
    <hunting-words-page />
  </d-container>
</template>

<script>
import HuntingWordsPage from '../components/HuntingWordsPage.vue';

export default {
  name: 'hunting-words-create',
  components: {
    HuntingWordsPage,
  },
};
</script>
